import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PrintGroupPaginatorService {

  restructure(host: HTMLElement, breakDepth: number) {
    const table = host.querySelector('table');
    const originalTbody = table?.querySelector('tbody');
    if (!table || !originalTbody) return;

    const getDepth = (row: HTMLTableRowElement): number => {
      const div = row.querySelector('td div') as HTMLElement;
      if (!div) return -1;
      return parseInt(div.style.paddingLeft || '0', 10) / 5;
    };

    originalTbody.setAttribute('data-print-original', 'true');
    const rows = Array.from(originalTbody.querySelectorAll('tr'));
    const groups: HTMLTableRowElement[][] = [];
    let currentGroup: HTMLTableRowElement[] = [];
    const parentRows: HTMLTableRowElement[] = [];
    let isInsideTargetGroup = false;

    rows.forEach(row => {
      const depth = getDepth(row);
      if (depth >= 0 && depth < breakDepth) {
        parentRows[depth] = row;
        parentRows.splice(depth + 1);

        if (!isInsideTargetGroup) {
          currentGroup.push(row);
        }
        return;
      }

      if (depth === breakDepth) {
        const hasContent = currentGroup.some(x => getDepth(x) >= breakDepth);
        if (currentGroup.length > 0 && hasContent) {
          groups.push(currentGroup);
        }

        currentGroup = [...parentRows, row];
        isInsideTargetGroup = true;
        return;
      }

      currentGroup.push(row);
    });
    if (currentGroup.length > 0) groups.push(currentGroup);

    groups.forEach((groupRows, index) => {
      const newTbody = document.createElement('tbody');
      newTbody.setAttribute('data-print-generated', 'true');
      if (index > 0) newTbody.style.breakBefore = 'page';
      groupRows.forEach(row => { newTbody.appendChild(row.cloneNode(true)); });
      table.appendChild(newTbody);
    });
  }

  revert(host: HTMLElement) {
    const table = host.querySelector('table');
    if (!table) return;

    const original = table.querySelector('tbody[data-print-original]') as HTMLElement;
    if (original) {
      original.removeAttribute('data-print-original');
    }

    table.querySelectorAll('tbody[data-print-generated]')
      .forEach(tb => tb.remove());
  }
}
